import {
  Phone,
  Mail,
  Building2,
  Calendar,
  BadgeCheck,
  User,
} from "lucide-react";

export default function ProfileHeader({
  customer,
  prescriptions = [],
}) {
  const avatar =
    customer?.customer_name?.charAt(0)?.toUpperCase() || "C";

  const totalPrescriptions = prescriptions.length;

  const formatDate = (date) => {
    if (!date) return "-";

    return new Date(date).toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    });
  };

  return (
    <div className="overflow-hidden rounded-[32px] border border-slate-200 bg-white shadow-sm">

      {/* Banner */}
      <div className="relative h-40 bg-gradient-to-r from-blue-600 via-indigo-600 to-violet-700">

        <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,rgba(255,255,255,.18),transparent_35%)]"></div>

      </div>

      {/* Profile */}
      <div className="relative px-8 pb-8">

        <div className="-mt-16 flex flex-col items-center text-center lg:flex-row lg:items-end lg:justify-between lg:text-left">

          {/* Left */}
          <div className="flex flex-col items-center lg:flex-row lg:items-end">

            {/* Avatar */}
            <div className="flex h-32 w-32 items-center justify-center rounded-full border-8 border-white bg-gradient-to-br from-blue-600 to-violet-700 text-5xl font-bold text-white shadow-xl">

              {avatar}

            </div>

            {/* Name */}
            <div className="mt-5 lg:ml-6 lg:mt-0">

              <div className="flex flex-wrap items-center justify-center gap-3 lg:justify-start">

                <h1 className="text-3xl font-bold text-slate-900">

                  {customer?.customer_name}

                </h1>

                <span className="rounded-full bg-emerald-100 px-4 py-1 text-sm font-semibold text-emerald-700">

                  {customer?.branch}

                </span>

              </div>

              <div className="mt-3 flex flex-wrap items-center justify-center gap-5 text-sm text-slate-600 lg:justify-start">

                <div className="flex items-center gap-2">

                  <BadgeCheck
                    size={16}
                    className="text-blue-600"
                  />

                  <span>

                    {customer?.customer_id}

                  </span>

                </div>

                <div className="flex items-center gap-2">

                  <Phone
                    size={16}
                    className="text-blue-600"
                  />

                  <span>

                    {customer?.phone || "-"}

                  </span>

                </div>

                <div className="flex items-center gap-2">

                  <Mail
                    size={16}
                    className="text-blue-600"
                  />

                  <span>

                    {customer?.email || "-"}

                  </span>

                </div>

              </div>

            </div>

          </div>

          {/* Right Stats */}
          <div className="mt-8 grid grid-cols-2 gap-4 lg:mt-0">

            <div className="rounded-2xl border border-slate-200 bg-slate-50 px-6 py-4 text-center">

              <p className="text-sm text-slate-500">
                Prescriptions
              </p>

              <h2 className="mt-2 text-3xl font-bold text-slate-900">

                {totalPrescriptions}

              </h2>

            </div>

            <div className="rounded-2xl border border-slate-200 bg-slate-50 px-6 py-4 text-center">

              <p className="text-sm text-slate-500">
                Registered
              </p>

              <h2 className="mt-2 text-base font-semibold text-slate-900">

                {formatDate(customer?.created_at)}

              </h2>

            </div>

          </div>

        </div>
                {/* Customer Details */}
        <div className="mt-10 grid grid-cols-1 gap-6 md:grid-cols-3">

          {/* DOB */}
          <div className="rounded-2xl border border-slate-200 bg-slate-50 p-5 transition hover:bg-white hover:shadow-sm">
            <div className="flex items-center gap-3">
              <div className="rounded-xl bg-blue-100 p-3">
                <Calendar className="text-blue-600" size={20} />
              </div>

              <div>
                <p className="text-sm text-slate-500">
                  Date of Birth
                </p>

                <h3 className="mt-1 font-semibold text-slate-900">
                  {formatDate(customer?.date_of_birth)}
                </h3>
              </div>
            </div>
          </div>

          {/* Branch */}
          <div className="rounded-2xl border border-slate-200 bg-slate-50 p-5 transition hover:bg-white hover:shadow-sm">
            <div className="flex items-center gap-3">
              <div className="rounded-xl bg-emerald-100 p-3">
                <Building2 className="text-emerald-600" size={20} />
              </div>

              <div>
                <p className="text-sm text-slate-500">
                  Branch
                </p>

                <h3 className="mt-1 font-semibold text-slate-900">
                  {customer?.branch || "-"}
                </h3>
              </div>
            </div>
          </div>

          {/* Visit For */}
          <div className="rounded-2xl border border-slate-200 bg-slate-50 p-5 transition hover:bg-white hover:shadow-sm">
            <div className="flex items-center gap-3">
              <div className="rounded-xl bg-violet-100 p-3">
                <User className="text-violet-600" size={20} />
              </div>

              <div>
                <p className="text-sm text-slate-500">
                  Visit For
                </p>

                <h3 className="mt-1 font-semibold text-slate-900">
                  {customer?.visit_for || "-"}
                </h3>
              </div>
            </div>
          </div>

          {/* Address */}
<div className="md:col-span-3 rounded-2xl border border-slate-200 bg-slate-50 p-6 transition hover:bg-white hover:shadow-sm">

  <p className="text-sm font-medium text-slate-500 text-center">
    Address
  </p>

  <div className="mt-4 flex justify-center">

    <p className="max-w-4xl text-center text-base font-semibold leading-7 text-slate-900 break-words">
      {customer?.address || "-"}
    </p>

  </div>

</div>

        </div>

      </div>

    </div>
  );
}